'use strict';

import {EwSiteApp} from '../../app/ewsiteapp.js';
import {CommunicationSubjectListCtrl} from './communicationsubjectlistctrl.js';
import {CommunicationMessageListCtrl} from './communicationmessagelistctrl.js';


EwSiteApp.controller('CommunicationSubjectListCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", "$mdDialog", CommunicationSubjectListCtrl]);
EwSiteApp.controller('CommunicationMessageListCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", "$mdDialog", CommunicationMessageListCtrl]);